export default __webpack_public_path__ + "static/Entenda0151-ff85f0d9fa99d70741f564affd901440.jpg";